import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ServicesGrid from '../components/Services';
import { getIcon } from '../lib/icons';
import { ourServices, scopeOfWork } from '../mock';

export default function ServicesPage() {
  return (
    <>
      <Header />
      <div className="page-hero" style={{ backgroundImage: 'url(https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)', paddingTop: '80px' }}>
        <div className="text-center max-w-3xl mx-auto px-6">
          <p className="uppercase text-xs tracking-[0.4em] mb-3 opacity-80">What We Offer</p>
          <h1 className="text-4xl md:text-6xl font-light" style={{ fontFamily: 'Playfair Display, serif' }}>Our Services</h1>
          <div className="mx-auto w-16 h-[2px] bg-white/70 mt-5" />
        </div>
      </div>

      <ServicesGrid />

      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10">
          <div>
            <p className="text-[color:var(--brand)] uppercase tracking-[0.4em] text-xs mb-3">Specialized</p>
            <h3 className="text-3xl font-light mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Our Services</h3>
            <ul className="space-y-3">
              {ourServices.map((s, i) => {
                const Ico = getIcon(s.icon);
                return (
                  <li key={i} className="flex items-center gap-3 p-3 border border-[color:var(--line)] rounded-md hover:border-[color:var(--brand)] hover:bg-[color:var(--brand-soft)]/40 transition-colors">
                    <span className="w-10 h-10 rounded-full bg-[color:var(--brand-soft)] text-[color:var(--brand)] inline-flex items-center justify-center"><Ico size={18} /></span>
                    <span className="text-[color:var(--ink)]">{s.name}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <p className="text-[color:var(--brand)] uppercase tracking-[0.4em] text-xs mb-3">Coverage</p>
            <h3 className="text-3xl font-light mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Scope of Work</h3>
            <ul className="space-y-3">
              {scopeOfWork.map((s, i) => {
                const Ico = getIcon(s.icon);
                return (
                  <li key={i} className="flex items-center gap-3 p-3 border border-[color:var(--line)] rounded-md hover:border-[color:var(--brand)] hover:bg-[color:var(--brand-soft)]/40 transition-colors">
                    <span className="w-10 h-10 rounded-full bg-[color:var(--brand-soft)] text-[color:var(--brand)] inline-flex items-center justify-center"><Ico size={18} /></span>
                    <span className="text-[color:var(--ink)]">{s.name}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
